import template from './swag-cms-extensions-form-editor-settings-group.html.twig';
import './swag-cms-extensions-form-editor-settings-group.scss';

const { mapPropertyErrors } = Shopware.Component.getComponentHelper();

export default {
    template,
    computed: {
        group() {
            return Shopware.Store.get('swCmsDetailCurrentCustomForm').activeItem;
        },

        ...mapPropertyErrors('group', [
            'technicalName',
        ]),
    },
}
